import { useHistory } from 'react-router-dom';

import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { firstOrNull } from 'common/utils/array';

import { useCampaignMutations } from './useCampaignMutations';
import { useCampaignsRoutes } from './useCampaignsRoutes';
import { useVenueAdCampaignMutations } from '../ad-campaign/hooks/useVenueAdCampaignMutations';

export const useCampaignHandlers = ({ merchantId, venueIds }: { merchantId: string; venueIds: string[] }) => {
  const { deleteCampaign, terminate } = useCampaignMutations({ merchantId, venueIds });
  const campaignsRoutes = useCampaignsRoutes();
  const history = useHistory();

  const { stopVenueAdCampaign, restartVenueAdCampaign } = useVenueAdCampaignMutations({
    venueId: firstOrNull(venueIds) ?? '',
  });

  const handleEditCampaign = (campaignId: string, campaignType: CampaignType) => {
    if (campaignType === CampaignType.ADS) {
      history.push(`${campaignsRoutes.edit(campaignId)}?campaignType=Ads`);
    } else {
      history.push(campaignsRoutes.edit(campaignId));
    }
  };

  const handleCloneCampaign = (campaignId: string) => {
    history.push(`${campaignsRoutes.new}?campaignId=${campaignId}`);
  };

  const handleDeleteCampaign = (campaignId: string) => {
    deleteCampaign.mutate({
      merchantId,
      campaignId,
    });
  };

  const handleTerminateCampaign = (campaignId: string) => {
    terminate.mutate({
      merchantId,
      campaignId,
    });
  };

  const handleStopCampaign = (campaignId: string) => stopVenueAdCampaign.mutate(campaignId);
  const handleRestartCampaign = (campaignId: string) => restartVenueAdCampaign.mutate(campaignId);

  return {
    handleEditCampaign,
    handleCloneCampaign,
    handleDeleteCampaign,
    handleTerminateCampaign,
    handleStopCampaign,
    handleRestartCampaign,
  };
};
